import { useEffect } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

export default function ProtectedRoute({ children }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { isLoggedIn, userType } = useSelector((state) => state.auth);
  const redirectToDashboard = (userTypeStr, dashboardPath) => {
    if (userType === "S" && !location.pathname.includes("admin")) return;
    !location.pathname.includes(userTypeStr) && navigate(dashboardPath);
  };
  useEffect(() => {
    if (!isLoggedIn) {
      navigate("/");
    } else if (userType) {
      switch (userType) {
        case "S":
          redirectToDashboard("seller", "/seller/dashboard");
          break;
        case "P":
          redirectToDashboard("user", "/user/dashboard");
          break;
        case "F":
          if (
            !location.pathname.includes("/affiliate/") &&
            !location.pathname.includes("/user/")
          ) {
            navigate("/affiliate/dashboard");
          }
          break;
        case "A":
          redirectToDashboard("admin", "/admin/dashboard");
          break;

        default:
          break;
      }
    }
  }, [isLoggedIn, userType]);

  return isLoggedIn ? children : children;
}
